import styled from 'styled-components';
import { ReactComponent as RawPCSmallSVG } from '../../../../assets/icons/icon_pc_small.svg';

export const IconPCSmall = styled(RawPCSmallSVG)``;
